var React = require('react');
var firebase = require('../../../firebase');
var toastr = require('toastr');
var when = require('when');

var { fbStorage } = firebase;

var Button = require('react-bootstrap/lib/Button');
var Modal = require('react-bootstrap/lib/Modal');
var Carousel = require('react-bootstrap/lib/Carousel');
var Form = require('react-bootstrap/lib/Form');
var FormControl = require('react-bootstrap/lib/FormControl');
var FormGroup = require('react-bootstrap/lib/FormGroup');
var ControlLabel = require('react-bootstrap/lib/ControlLabel');

var style = {
	container: {
		margin: 10
	}
};

var Files = React.createClass({

	getInitialState() {
    	return {
    		opened: false,
    		bank: "",
    		agency: "",
    		account: "",
    		name: "",
    		cpf: ""
    	};
  	},

  	load: function() {
  		var me = this;
  		if(me.props.rowData.paymentData) {
  			me.state.bank = me.props.rowData.paymentData.bank;
			me.state.agency = me.props.rowData.paymentData.agency;
			me.state.account = me.props.rowData.paymentData.account;
			me.state.name = me.props.rowData.paymentData.name;
			me.state.cpf = me.props.rowData.paymentData.cpf;
  		}
  	},

  	save() {
  		var me = this;
  		var key = me.props.rowData.id + "/info/paymentData"
  		var data = {
  			bank: me.state.bank,
			agency: me.state.agency,
			account: me.state.account,
			name: me.state.name,
			cpf: me.state.cpf
  		}
		me.props.update(key, data);
  	  	me.close();
  	},

  	open() {
  		
  		var me = this;

  		me.load();
  		
  		this.setState({opened: true});
  	},

  	close() {
  	  this.setState({opened: false});
  	},

  	onInputChange: function(e) {
	    this.setState({[e.target.name]: e.target.value});
	},

	render() {
		var me = this;
		let bank = me.state.bank;
		let agency = me.state.agency;
		let account = me.state.account;
		let name = me.state.name;
		let cpf = me.state.cpf;

    	return (
    		<div>
	    		<Button 
	    			onClick={me.open}
	    			bsSize="small"
	    			bsStyle="primary">
	    			{"Dados bancários"}
	    		</Button>
	    		
	    		<Modal show={me.state.opened} onHide={me.close}>
	    			<div style={style.container}>
		    			<Form onChange={me.onInputChange} className="initOrder activebox">
							<FormGroup  controlId="formBank">
							<ControlLabel>Banco:</ControlLabel>
								<FormControl 
									name="bank"
									type="text"
									value={bank}
									data-checkout="cardholderName" 
									placeholder="Banco"
									onChange={me.onInputChange}
								/>
							</FormGroup>
							<FormGroup  controlId="formAgency">
							<ControlLabel>Agência:</ControlLabel>
								<FormControl
									name="agency"
									type="text"
									value={agency}
									data-checkout="cardholderName" 
									placeholder="Agência"
									onChange={me.onInputChange}
								/>
							</FormGroup>
							<FormGroup  controlId="formAccount">
							<ControlLabel>Conta:</ControlLabel>
								<FormControl 
									name="account"
									type="text"
									value={account}
									data-checkout="cardholderName" 
									placeholder="Conta"
									onChange={me.onInputChange}
								/>
							</FormGroup>
							<FormGroup  controlId="formName">
							<ControlLabel>Nome:</ControlLabel>
								<FormControl 
									name="name"
									type="text"
									value={name}
									data-checkout="cardholderName" 
									placeholder="Nome"
									onChange={me.onInputChange}
								/>
							</FormGroup>
							<FormGroup  controlId="formCPF">
							<ControlLabel>CPF:</ControlLabel>
								<FormControl
									name="cpf"
									type="text"
									value={cpf}
									data-checkout="cardholderName" 
									placeholder="CPF"
									onChange={me.onInputChange}
								/>
							</FormGroup>
							<FormGroup  controlId="formButton">
								<Button onClick={me.save}
										block
										bsStyle="primary"
										style={{width: '50%', backgroundColor: '#5CB85C', borderColor: '#4CAE4C', color: '#FFFFFF'}}>
										{"Salvar"}
								</Button>
							</FormGroup>
						</Form>
					</div>
				</Modal>
	    	</div>
    	);
  	}

});

module.exports = Files;


// WEBPACK FOOTER //
// ./src/components/Admin/Couriers/Bank.jsx